<script setup>
import { computed } from 'vue';
import { useCompetitorAppConfig } from 'src/composables/useCompetitorAppConfig';
import { sortArray } from 'utils';
import TechnicalPropertiesByMedium from './TechnicalPropertiesByMedium.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  color: {
    type: String,
    required: false,
    default: '#7a7a7a',
  }
});

const { getApplicationType, getMedium, getTechnicalPropertyType } = useCompetitorAppConfig();

const technicalProperties = computed(() => (
  props.product?.technicalProperties
    ?.map((row) => ({
      ...row,
      applicationTypeConfig: getApplicationType(row.applicationType),
      mediumConfig: getMedium(row.medium),
      propertyTypeConfig: getTechnicalPropertyType(row.propertyType),
    }))
));

const hasTechnicalProperties = computed(() => (
  technicalProperties.value
  && Array.isArray(technicalProperties.value)
  && technicalProperties.value.length > 0
));

const byMedium = computed(() => {
  const result = {};

  sortArray(technicalProperties.value, 'mediumConfig.title').forEach((row) => {
    if (!result[row.medium]) {
      result[row.medium] = [];
    }

    result[row.medium].push(row);
  });

  return result;
});
</script>

<template>
  <div
    class="ce-technicalProperties mt5"
    v-if="hasTechnicalProperties">
    <h2 class="ce-productDetailsHeadline">
      {{ $t('competitorApp.v2.productDetails.technicalProperties.headline') }}
    </h2>

    <TechnicalPropertiesByMedium
      v-for="(techProps, mediumCode) in byMedium"
      :key="mediumCode"
      :medium-code="mediumCode"
      :technical-properties="techProps"
      :color="color" />
  </div>
</template>
